// Translate hero UI labels → portal payload values so the prefill blob the
// hero hands off to the portal uses the same field names the portal already
// understands (mirrors AssetCreateOptions.tsx around lines 2120 / 2458–2517).

const AI_MODEL_MAP = {
    "Recommended":     "auto",
    "Nano Banana Pro": "nano_banana",
    "ChatGPT 2":       "openai",
    "Flux":            "flux",
};

const ASPECT_RATIO_MAP = {
    "Square":    "1:1",
    "Landscape": "16:9",
    "Portrait":  "9:16",
};

export const mapAiModel = (label) => AI_MODEL_MAP[label] || "auto";

export const mapAspectRatio = (label) => ASPECT_RATIO_MAP[label] || "1:1";

export const mapNumImages = (label) => {
    const n = parseInt(String(label || "").trim(), 10);
    return Number.isFinite(n) && n > 0 ? n : 4;
};

// Keep values 1:1 with the portal's `videoModeType` enum (UploadStage line ~2103).
const VIDEO_MODE_TYPE_MAP = {
    "Custom Video":     "custom",
    "360° Spin":        "panorama_360",
    "Influencer Video": "influencer",
};

const VIDEO_MODEL_MAP = {
    "Veo 3":    "veo3",
    "Gen 4.5":  "gen4.5",
    "Seedance": "seedance",
};

export const mapVideoModeType = (label) => VIDEO_MODE_TYPE_MAP[label] || "custom";
export const mapVideoModel = (label) => VIDEO_MODEL_MAP[label] || "veo3";

const SPATIAL_TYPE_MAP = {
    "Scene":   "scene",
    "Product": "product",
};

const SPATIAL_MODEL_MAP = {
    "Tripo":    "tripo",
    "Trellis2": "trellis2",
};

export const mapSpatial3DMode = (label) => SPATIAL_TYPE_MAP[label] || "scene";
export const mapProduct3DModel = (label) => SPATIAL_MODEL_MAP[label] || "tripo";

// Build the `selections` block that goes into the prefill payload. Includes the
// flat portal field names (ai_model, aspect_ratio, num_of_images) for the
// image mode plus the raw display labels (so the round-trip preserves UI state
// when the user lands on the portal).
export const buildPortalSelections = (activeType, modeSelections) => {
    if (activeType === "image") {
        return {
            ai_model: mapAiModel(modeSelections.model),
            aspect_ratio: mapAspectRatio(modeSelections.orientation),
            num_of_images: mapNumImages(modeSelections.count),
            // raw labels for the portal-side decoder follow-up
            display: modeSelections,
        };
    }
    if (activeType === "video") {
        return {
            video_mode_type: mapVideoModeType(modeSelections.videoMode),
            model: mapVideoModel(modeSelections.model),
            duration: modeSelections.duration,        // already "4s"/"6s"/...
            resolution: modeSelections.resolution,    // "720p"/"1080p"
            display: modeSelections,
        };
    }
    if (activeType === "spatial") {
        return {
            spatial_3d_mode: mapSpatial3DMode(modeSelections.type),
            product_3d_model: mapProduct3DModel(modeSelections.model),
            display: modeSelections,
        };
    }
    return { display: modeSelections };
};
